<template>
  <v-container>
    <v-row>
      <v-col>
        <base-error-alert :error="error" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'TheAppError',
  props: {
    error: {
      type: Error,
      required: true,
    },
  },
};
</script>
